export default {"src":"/_next/static/media/image_pdf_detail.1f67f957.svg","height":151,"width":221,"blurWidth":0,"blurHeight":0};